<template>
	<div v-if="page !== undefined">
		<div class="al_right mgr_10" v-if="page">Total Count : {{ page.totalElements | commaSeparated }}</div>
		<div v-if="!(page.last && page.first)" class="paging_nav">
			<a v-if="!page.first" href="javascript:void(0);" @click="gotoPage((currentBlock - 1 < 0 ? 0 : currentBlock - 1) * pageCount)" class="page_select prev_page">Prev</a>
			<span>
				<template v-for="first in last">
					<template v-if="first + currentBlock * pageCount === page.number + 1">
						<strong v-bind:key="first">{{ first + currentBlock * pageCount }}</strong>
					</template>
					<template v-else>
						<a href="javascript:void(0);" @click="gotoPage(first - 1 + currentBlock * pageCount)" v-bind:key="first"> {{ first + currentBlock * pageCount }}</a>
					</template>
				</template>
			</span>
			<a v-if="!page.last" href="javascript:void(0)" @click="gotoPage(next)" class="page_select next_page">Next</a>
		</div>
	</div>
</template>
<script>
export default {
	props: ['page'],
	data: function() {
		return {
			pageCount: 10,
			next: '',
		};
	},
	methods: {
		renderPaging() {
			if (this.page) {
				this.currentBlock = Math.floor(this.page.number / this.pageCount);
				this.first = this.currentBlock * this.pageCount;
				this.last = this.currentBlock * this.pageCount + this.pageCount;
				if (this.last > this.page.totalPages) this.last = Math.floor(this.page.totalPages % this.pageCount);
				this.prev = this.first - 1;
				this.next = (this.last + this.currentBlock * this.pageCount > this.page.totalPages ? this.page.totalPages - 1 : this.last + 1 + this.currentBlock * this.pageCount) - 1;
			}
		},
		gotoPage(page) {
			this.$emit('gotoPage', page);
		},
	},
	watch: {
		page: function() {
			this.renderPaging();
		},
	},
	created() {
		this.renderPaging();
	},
};
</script>

<style></style>
